import { Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { AuthHeader } from './AuthHeader';
import { authPrimaryButtonClassName } from './auth-presentation.consts';
import { type AuthProgressProps } from './auth.types';

export const AuthProgress = ({ title, description, buttonLabel, heading = 'h1' }: AuthProgressProps) => {
  return <div role="status" className="space-y-7">
    <AuthHeader title={title} description={description} heading={heading} />
    <Button type="button" className={authPrimaryButtonClassName} disabled aria-busy="true">
      <Loader2 aria-hidden="true" className="mr-2 h-4 w-4 shrink-0 animate-spin motion-reduce:animate-none" />
      <span>{buttonLabel}</span>
    </Button>
  </div>;
};
